import React, { useEffect, useState } from "react";
import axiosApi from "../../utilities/axiosApi";
import CommonFormLabel from "../common-form-label/index";
import RadioButton from "../radio-button/index";

/**
 * Lets the customer pick which WhatsApp number this client's campaigns go out
 * from.
 *
 * This sets the default a new campaign opens with. The campaign builder asks
 * again per campaign and its answer is what finalise honours, so changing this
 * never alters a campaign that already exists.
 *
 * Every customer may use either number, so the only reason this renders nothing
 * is not having the rates yet.
 */
export default function SenderTypeChoice({ value, onChange, disabled }) {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    let active = true;

    axiosApi
      .get("/api/customer/sender-options")
      .then((res) => {
        if (active && res?.data?.success) {
          setOptions(res.data.data);
        }
      })
      .catch(() => {
        // Never block the form over this. Without an answer the customer keeps
        // the default of their own number, which is what they have today.
        if (active) setOptions(null);
      });

    return () => {
      active = false;
    };
  }, []);

  if (!options) {
    return null;
  }

  const rate = (credits) =>
    `${credits} credit${Number(credits) === 1 ? "" : "s"} per guest`;

  return (
    <div className="common-mb-space">
      <CommonFormLabel htmlFor="sender_type" title="Send invitations from" />

      <RadioButton
        name="sender_type"
        id="sender_type_personal"
        value="personal"
        checked={value !== "official"}
        onChange={onChange}
        disabled={disabled}
        label={`My own WhatsApp number — ${rate(options.personal_credit_rate)}`}
      />
      <small className="d-block text-muted mb-2 ms-4">
        You scan a QR code to connect your number. Messages come from you.
      </small>

      <RadioButton
        name="sender_type"
        id="sender_type_official"
        value="official"
        checked={value === "official"}
        onChange={onChange}
        disabled={disabled}
        label={`Our official WhatsApp number — ${rate(options.official_credit_rate)}`}
      />
      <small className="d-block text-muted ms-4">
        No QR code needed. Uses pre-approved message templates, so the wording is
        fixed. Text and PDF invitations only.
      </small>
    </div>
  );
}
